import React, { useEffect, Component } from 'react';
// Custom hook to handle smooth scrolling
export const useSmoothScroll = () => {
  useEffect(() => {
    // Function to handle anchor link clicks
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a');
      if (!anchor) return;
      // Check if the link is an internal anchor link
      const href = anchor.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        e.preventDefault();
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        });
        // Update URL without causing a jump
        window.history.pushState(null, '', href);
      }
    };
    // Add event listener for all clicks
    document.addEventListener('click', handleAnchorClick);
    // Clean up event listener
    return () => {
      document.removeEventListener('click', handleAnchorClick);
    };
  }, []);
};
// Component wrapper for smooth scrolling
export const SmoothScroll: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  useSmoothScroll();
  return <>{children}</>;
};